import React from 'react'
import { SafeAreaView, View, Text } from 'react-native'
import { IconButton, Caption } from 'react-native-paper'
import { useNavigation } from '@react-navigation/native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { GetIcon } from '../atoms/GetIcon'
import { BackHeader } from '../../assets/icons'
import { ReactElement } from 'react'
import { DrawerActions } from '@react-navigation/native'

type ToolbarProps = {
  leftComponent?: ReactElement
  title?: string
  titleStyle?: any
  subTitle?: string
  centerComponent?: ReactElement
  rightComponent?: ReactElement
  back?: boolean
  subComponent?: Element
  headerStyle?: any
}

type HeaderButtonProps = {
  onPress?: () => void
  icon?: ReactElement | string
  back?: boolean
  menu?: string
}

export const HeaderButton = ({
  onPress,
  icon,
  back = false,
  menu,
}: HeaderButtonProps) => {
  const navigation = useNavigation()
  let iconName: string | ReactElement | undefined = icon
  if (back) {
    iconName = (
      <GetIcon
        icon={<BackHeader height="20" width="20" />}
        onPress={() => navigation.goBack()}
      />
    )
  } else if (menu) {
    iconName = 'menu'
  }
  return (
    <IconButton
      icon={() => iconName}
      size={30}
      onPress={() => {
        if (onPress) {
          onPress()
        } else if (back) {
          navigation.goBack()
        } else if (menu) {
          navigation.dispatch(DrawerActions.toggleDrawer())
        }
      }}
    />
  )
}

export const Toolbar = ({
  leftComponent,
  title = '',
  titleStyle = {},
  subTitle = '',
  centerComponent,
  rightComponent,
  back = false,
  subComponent,
  headerStyle,
  ...rest
}: ToolbarProps) => {
  const left = back ? (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <HeaderButton back={back} {...rest} />
      {leftComponent}
    </View>
  ) : (
    leftComponent
  )
  const center = title ? (
    <View
      style={composeStyle(
        { flex: 1, justifyContent: 'space-around', marginLeft: 10 },
        titleStyle,
      )}
    >
      <Text
        style={{ fontSize: 18, fontWeight: '600' }}
        ellipsizeMode="tail"
        numberOfLines={1}
      >
        {title}
      </Text>
      {subTitle && (
        <Caption ellipsizeMode="tail" numberOfLines={1}>
          {subTitle}
        </Caption>
      )}
    </View>
  ) : (
    centerComponent
  )
  return (
    <SafeAreaView style={{ top: 0, left: 0, right: 0 }}>
      <View
        style={{
          height: 60,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingHorizontal: 10,
          marginBottom: 16,
          ...headerStyle,
        }}
      >
        {left}
        {center}
        {rightComponent}
      </View>
      {subComponent}
    </SafeAreaView>
  )
}
